<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/head/reports'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2 class="text-dark">گزارش‌ها</h2>

      <hr class="my-4" />
      <h5 class="text-primary">
        مدیر گرامی، در این بخش می توانید گزارش‌ها درباره ی پروژه های ثبت شده را
        مشاهده فرمایید
      </h5>
      <hr class="my-4" />
      <h4 class="my-4 text-center">نمودار تمامی درخواست‌های ثبت شده</h4>
      <div class="text-center" v-if="pieBusy">
        <b-spinner variant="primary" type="grow"></b-spinner>
      </div>
      <div v-else class="container animated fadeIn">
        <!-- NOTE using chartkick for pieChart  -->
        <Chart
          name="pieChart"
          :chartdata="dataBar1"
          :options="optionsBar1"
          type="pie"
          :height="300"
        >
        </Chart>
      </div>
      <hr />
      <h4 class="my-4 text-center">
        نمودار کاربران عضو شده و درخواست های فعال
      </h4>
      <div class="text-center" v-if="barBusy">
        <b-spinner variant="primary" type="grow"></b-spinner>
      </div>
      <div v-else class="container animated fadeIn">
        <!-- NOTE using chartkick for pieChart  -->
        <Chart
          name="barChart"
          :chartdata="dataBar2"
          :options="optionsBar2"
          type="bar"
        ></Chart>
      </div>
    </b-card>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";

export default {
  components: { Chart },
  data() {
    return {
      pieBusy: false,
      barBusy: false,
      role: '',
      requestCharts: "",
      usersChart: "",
      dataBar1: {
        labels: [],
        datasets: [],
      },
      optionsBar1: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },
      },
      dataBar2: {
        labels: [],
        datasets: [],
      },
      optionsBar2: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
    };
  },

  methods: {
    getChartsInfo() {
      this.barBusy = true;
      this.pieBusy = true;
      //pie chart
      this.$http
        .post(
          this.baseUrl + "/setad/"+this.role+"/reports/curves/pieChart",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.dataBar1 = res.data;
            setTimeout(() => {
              this.pieBusy = false;
            }, 500);
          }
        });
      // bar chart
      this.$http
        .post(
          this.baseUrl + "/setad/"+this.role+"/reports/curves/curveChart",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.dataBar2 = res.data;
            setTimeout(() => {
              this.barBusy = false;
            }, 500);
          }
        });
    },
  },
  updated() {},
  mounted() {
    this.role = localStorage.getItem('role');
    this.getChartsInfo();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.bg-primary {
  background-color: #4730c5 !important;
}
.text-danger {
  color: #9b5da5 !important;
}

.btn-light {
  color: #fff;
  background-color: #393a77;
}

.btn-light:hover {
  color: #fff;
  background-color: #3e5cc2;
  border-color: #b173a2;
}

.color {
  background-color: #0c4961;
  color: white;
}

.btn-newRequest {
  border-radius: 15px 50px !important;
}
</style>
